// extracted by mini-css-extract-plugin
export default {"toolbar":"style_toolbar__OucEr"};